/*pages*/
(function () {
  function initSlider(root) {
    const track = root.querySelector("[data-cvs-track]");
    const items = root.querySelector(".cvs__items");
    const dotsWrap = root.querySelector("[data-cvs-dots]");
    const prevBtn = root.querySelector("[data-cvs-prev]");
    const nextBtn = root.querySelector("[data-cvs-next]");
    const isLoopEnabled = root.dataset.cvsLoop === "true";

    if (!track || !items) return;

    if (root._cvsDestroy) {
      root._cvsDestroy();
    }

    const originalSlides = Array.from(items.children).filter((el) =>
      el.classList.contains("cvs__slide")
    );

    if (!originalSlides.length) return;

    let isAdjusting = false;
    let isDown = false;
    let startX = 0;
    let startScroll = 0;
    let didDrag = false;
    let scrollEndTimer = null;
    const DRAG_THRESHOLD = 6;

    function getPageWidth() {
      return track.clientWidth;
    }

    function getGap() {
      const style = window.getComputedStyle(items);
      const gap = parseFloat(style.columnGap || style.gap || "0");
      return Number.isNaN(gap) ? 0 : gap;
    }

    function getSlideWidth() {
      const slide = items.querySelector(".cvs__slide");
      if (!slide) return 0;
      return slide.getBoundingClientRect().width;
    }

    function getStepWidth() {
      return getSlideWidth() + getGap();
    }

    function getVisiblePerPage() {
      const step = getStepWidth();
      const page = getPageWidth();
      if (!step || !page) return 1;

      return Math.max(1, Math.round(page / step));
    }

    function getOriginalCount() {
      return originalSlides.length;
    }

    function getPageCount() {
      const total = getOriginalCount();
      const perPage = getVisiblePerPage();
      return Math.max(1, Math.ceil(total / perPage));
    }

    function getLoopSpan() {
      const step = getStepWidth();
      return step * getOriginalCount();
    }

    function getBaseOffset() {
      return getLoopSpan();
    }

    function getMaxScroll() {
      return Math.max(0, track.scrollWidth - track.clientWidth);
    }

    function getNormalizedScrollLeft() {
      if (!isLoopEnabled) {
        return track.scrollLeft;
      }

      const loopSpan = getLoopSpan();
      const baseOffset = getBaseOffset();
      let x = track.scrollLeft - baseOffset;

      if (!loopSpan) return 0;

      while (x < 0) x += loopSpan;
      while (x >= loopSpan) x -= loopSpan;

      return x;
    }

    function normalizeScroll() {
      if (!isLoopEnabled || isAdjusting) return;

      const loopSpan = getLoopSpan();
      const baseOffset = getBaseOffset();
      const x = track.scrollLeft;

      if (!loopSpan) return;

      if (x < baseOffset - loopSpan * 0.5) {
        isAdjusting = true;
        track.scrollLeft = x + loopSpan;
        isAdjusting = false;
      } else if (x >= baseOffset + loopSpan * 1.5) {
        isAdjusting = true;
        track.scrollLeft = x - loopSpan;
        isAdjusting = false;
      }
    }

    function getCurrentPage() {
      const pageWidth = getPageWidth();
      const pageCount = getPageCount();
      const x = getNormalizedScrollLeft();

      if (!pageWidth) return 0;

      const pageIndex = Math.round(x / pageWidth);

      return Math.max(0, Math.min(pageIndex, pageCount - 1));
    }

    function getLoopedTarget(pageIndex) {
      const pageWidth = getPageWidth();
      return getBaseOffset() + pageIndex * pageWidth;
    }

    function goToPage(pageIndex, smooth = true) {
      const pageCount = getPageCount();
      let index = pageIndex;

      if (isLoopEnabled) {
        if (index < 0) index = pageCount - 1;
        if (index >= pageCount) index = 0;
      } else {
        index = Math.max(0, Math.min(index, pageCount - 1));
      }

      const target = isLoopEnabled
        ? Math.min(Math.max(0, getLoopedTarget(index)), getMaxScroll())
        : Math.min(Math.max(0, index * getPageWidth()), getMaxScroll());

      track.scrollTo({
        left: target,
        behavior: smooth ? "smooth" : "auto",
      });
    }

    function snapToNearestPage() {
      goToPage(getCurrentPage());
    }

    function buildDots() {
      if (!dotsWrap) return;

      dotsWrap.innerHTML = "";
      const pages = getPageCount();

      if (pages <= 1) return;

      for (let i = 0; i < pages; i++) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "cvs__dot";
        dot.setAttribute("aria-label", `Go to slide ${i + 1}`);

        dot.addEventListener("click", () => {
          goToPage(i);
        });

        dotsWrap.appendChild(dot);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;

      const current = getCurrentPage();
      const dots = dotsWrap.querySelectorAll(".cvs__dot");

      dots.forEach((dot, i) => {
        dot.setAttribute("aria-current", i === current ? "true" : "false");
      });
    }

    function updateArrows() {
      if (isLoopEnabled) {
        if (prevBtn) prevBtn.disabled = false;
        if (nextBtn) nextBtn.disabled = false;
        return;
      }

      const current = getCurrentPage();
      const lastPage = getPageCount() - 1;

      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= lastPage;
    }

    function refreshUI() {
      updateDots();
      updateArrows();
    }

    function removeClones() {
      items.querySelectorAll('[data-cvs-clone="true"]').forEach((el) => el.remove());
    }

    function cloneSlides() {
      const currentOriginals = Array.from(items.children).filter(
        (el) => el.classList.contains("cvs__slide") && el.getAttribute("data-cvs-clone") !== "true"
      );

      const prependFrag = document.createDocumentFragment();
      const appendFrag = document.createDocumentFragment();

      currentOriginals.forEach((slide) => {
        const beforeClone = slide.cloneNode(true);
        beforeClone.setAttribute("data-cvs-clone", "true");
        beforeClone.setAttribute("aria-hidden", "true");
        beforeClone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
        prependFrag.appendChild(beforeClone);

        const afterClone = slide.cloneNode(true);
        afterClone.setAttribute("data-cvs-clone", "true");
        afterClone.setAttribute("aria-hidden", "true");
        afterClone.querySelectorAll("[id]").forEach((el) => el.removeAttribute("id"));
        appendFrag.appendChild(afterClone);
      });

      items.prepend(prependFrag);
      items.append(appendFrag);
    }

    function normalizeStructure() {
      removeClones();

      if (isLoopEnabled) {
        cloneSlides();
      }
    }

    function resetToMiddleSet() {
      if (isLoopEnabled) {
        track.scrollLeft = getBaseOffset();
      } else {
        track.scrollLeft = 0;
      }
    }

    const onClickCapture = (e) => {
      if (!didDrag) return;
      e.preventDefault();
      e.stopPropagation();
    };

    const onPointerDown = (e) => {
      if (e.target.closest("a, button, input, select, textarea, label")) return;

      isDown = true;
      didDrag = false;

      if (track.setPointerCapture) {
        track.setPointerCapture(e.pointerId);
      }

      startX = e.clientX;
      startScroll = track.scrollLeft;
    };

    const onPointerMove = (e) => {
      if (!isDown) return;

      const dx = e.clientX - startX;

      if (!didDrag && Math.abs(dx) > DRAG_THRESHOLD) {
        didDrag = true;
      }

      track.scrollLeft = startScroll - dx;
    };

    const endDrag = () => {
      isDown = false;

      setTimeout(() => {
        didDrag = false;
      }, 0);
    };

    const onScroll = () => {
      normalizeScroll();
      refreshUI();

      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(() => {
        if (isLoopEnabled) {
          snapToNearestPage();
        }
      }, 120);
    };

    const onResize = () => {
      normalizeStructure();
      buildDots();
      resetToMiddleSet();
      refreshUI();
    };

    const onPrevClick = () => {
      goToPage(getCurrentPage() - 1);
    };

    const onNextClick = () => {
      goToPage(getCurrentPage() + 1);
    };

    normalizeStructure();

    track.addEventListener("click", onClickCapture, true);
    track.addEventListener("pointerdown", onPointerDown);
    track.addEventListener("pointermove", onPointerMove);
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    track.addEventListener("pointerleave", endDrag);
    track.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onResize);

    if (prevBtn) {
      prevBtn.addEventListener("click", onPrevClick);
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", onNextClick);
    }

    requestAnimationFrame(() => {
      resetToMiddleSet();
      buildDots();
      refreshUI();
    });

    root._cvsDestroy = () => {
      track.removeEventListener("click", onClickCapture, true);
      track.removeEventListener("pointerdown", onPointerDown);
      track.removeEventListener("pointermove", onPointerMove);
      track.removeEventListener("pointerup", endDrag);
      track.removeEventListener("pointercancel", endDrag);
      track.removeEventListener("pointerleave", endDrag);
      track.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onResize);

      if (prevBtn) {
        prevBtn.removeEventListener("click", onPrevClick);
      }

      if (nextBtn) {
        nextBtn.removeEventListener("click", onNextClick);
      }

      clearTimeout(scrollEndTimer);
      removeClones();

      if (dotsWrap) {
        dotsWrap.innerHTML = "";
      }
    };
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-cvs]").forEach(initSlider);
  });

  document.addEventListener("shopify:section:load", (e) => {
    const root = e.target.querySelector("[data-cvs]");
    if (root) initSlider(root);
  });

  document.addEventListener("shopify:block:select", (e) => {
    const root = e.target.closest(".shopify-section")?.querySelector("[data-cvs]");
    if (root) initSlider(root);
  });

  window.initColorVariantSlider = (scope = document) => {
    const ctx = scope instanceof Element ? scope : document;
    ctx.querySelectorAll("[data-cvs]").forEach(initSlider);
  };

  document.addEventListener("cvs:reinit", (e) => {
    window.initColorVariantSlider(e.detail?.root || document);
  });
})();